/**
 * 工作台首页轮播：无租户配置时使用的默认 5 张。
 */
import banner01 from '@/assets/home/workbench-banner-01.png'
import banner02 from '@/assets/home/workbench-banner-02.png'
import banner03 from '@/assets/home/workbench-banner-03.png'
import banner04 from '@/assets/home/workbench-banner-04.png'
import banner05 from '@/assets/home/workbench-banner-05.png'

export interface WorkbenchSlide {
  image: string
  alt: string
  background?: string
}

export const DEFAULT_WORKBENCH_BANNERS: WorkbenchSlide[] = [
  {
    image: banner01,
    alt: '你的专属智能工作台 效率提升 300%',
    background: '#f3f0ff'
  },
  {
    image: banner02,
    alt: '10w+ 企业信赖 · 定制开发平台',
    background: '#fff8e8'
  },
  {
    image: banner03,
    alt: 'AI应用开发 智能构建 · 快速落地',
    background: '#eef6ff'
  },
  {
    image: banner04,
    alt: 'AI数字员工 高效协同 · 智能执行',
    background: '#eef6ff'
  },
  {
    image: banner05,
    alt: 'AI 赋能 商业与服务',
    background: '#eef6ff'
  }
]
